var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.person && _vm.person.photo
    ? _c(
        "div",
        { staticClass: "member" },
        [
          _c("team-member-title", { attrs: { person: _vm.person } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wrapper" },
            [
              _c("team-member-media", { attrs: { person: _vm.person } }),
              _vm._v(" "),
              _c("team-member-caption", { attrs: { person: _vm.person } }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }